import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

interface ExtStyledProps {
  extStyled?: Record<string, unknown>; // Definisikan tipe data untuk prop Anda
}

export const ButtonResetStyle = styled('button', {
  shouldForwardProp: (prop) => prop !== 'extStyled',
})<ExtStyledProps>(({ theme, extStyled }) => ({
  padding: '8px 14px',
  background: 'none',
  border: 'none',
  font: 'inherit',
  color: 'inherit',
  cursor: 'pointer',
  textAlign: 'left',
  // width: '100%',

  display: 'flex',
  // gap: '12px',

  // '&:hover': {
  //   backgroundColor: theme.palette.action.hover,
  // },

  '&:focus': {
    outline: 'none',
  },

  '&:focus-visible': {
    outline: '2px solid #2563eb',
    outlineOffset: '2px',
  },
  ...extStyled
}))

export const CustomButton: React.FunctionComponent<ButtonProps> = (props) => {
  const { id, name, variant, className, onClick, startIcon, endIcon, ...properties } = props;
  return (
    <Button
      className={className}
      sx={{ textTransform: 'none' }}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      id={id}
      {...properties}
    >
      {name}
    </Button>
  );
};
